import { range, of } from 'rxjs';
import { delay, concatMap } from 'rxjs/operators';
export var presetTimer = function (delays, scheduler) {
    return range(delays.length).pipe(concatMap(function (index) { return of(index).pipe(delay(delays[index], scheduler)); }));
};
//# sourceMappingURL=presetTimer.js.map